export default __webpack_public_path__ + "static/media/Roof.20042450.jpg";